import React from 'react'

import { CountryCode } from '@app/consts/Countries'

import { PlaceholderIcon } from '@ui/icons/Placeholder.icon'

const files = import.meta.glob('./*.svg', { eager: true, as: 'url' }) as Record<string, string>

const byId: Record<string, string> = {}
for (const [p, url] of Object.entries(files)) {
  const m = p.match(/\/([A-Za-z0-9_-]+)\.svg$/)
  if (m) byId[m[1].toUpperCase()] = url
}

export type FlagIconProps = {
  countryCode: CountryCode
  className?: string
  title?: string
  size?: number
  alt?: string
  style?: React.CSSProperties
  fallback?: React.ReactNode
}

const normalizeToA3OrA2 = (code: CountryCode) => {
  const c = (code || '').trim().toUpperCase()
  if (c.length === 3 || c.length === 2) return c
  return null
}

export const FlagIcon: React.FC<FlagIconProps> = ({
  countryCode,
  className,
  title,
  alt,
  style,
  size = 24,
  fallback = <PlaceholderIcon color='text-inverse-black-neutral' />,
}) => {
  if (!countryCode) {
    return fallback
  }

  const src = getRichFlag(countryCode)

  if (!src) {
    return <>{fallback}</>
  }

  return (
    <img
      src={src}
      width={size}
      height={size}
      className={className}
      style={{ ...style, width: size, height: size }}
      title={title}
      alt={alt}
    />
  )
}

export const getRichFlag = (countryCode?: CountryCode | null): string | null => {
  if (!countryCode) {
    return null
  }

  const a3 = normalizeToA3OrA2(countryCode === 'LFT' ? 'MYS' : countryCode)

  return a3 ? byId[a3] : null
}
